import dayjs from "dayjs"

export const trackShareCampaignClick = (params = { userId: null, campaignName: "", campaignId: null }) => {
  const { userId, campaignName, campaignId } = params
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "Share_Campaign_link",
      ecommerce: {
        trigger_time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        screen_name: "Campaign_page",
        user_id: userId,
        campaign_name: campaignName,
        campaign_id: campaignId,
        platform: "web"
      }
    })
  }
}

export const trackSharePDPLink = (params = { userId: null, wareName: "", wareId: null }) => {
  const { userId, wareName, wareId } = params
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "Share_PDP_link",
      ecommerce: {
        trigger_time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        screen_name: "PDP",
        user_id: userId,
        item_name: wareName,
        item_id: wareId,
        platform: "web"
      }
    })
  }
}
